import { getAPIUrl } from '../api/API'
import { TitleDeedAccessResponse } from '../api/titleDeed'

export const NCA_TEXT =
  'As required by NCR reports will only be available for 72 hours'
export const RESTRICTED_REPORT =
  'You do not have access to this report, please consult with your administrator to give you access.'
export const REPORTID_SUBHEADING =
  'Perform a Consumer Profile search on its own or in conjunction with other Consumer Profiles to obtain comprehensive credit data on an individual.'
export const PRECHECK_SUBHEADING =
  'By searching the ID, a scan is performed to check the credit score.'
export const CONSUMER_TRACE_SUBHEADING =
  'A Search to assist in tracking down an individual.'
export const HISTORY_SUBHEADING =
  'Please find a list of reports requested in the past. Note that some reports have expired, and you will have to request them again if you did not save them.'
export const BRIDGING_SUBHEADING =
  "If you're tired of waiting for Estate Agent's commission or the proceeds from the registration of a bond/sale, let General Finance (GenFin) do the waiting​."
export const PRODUCT_ID = 153
export const XDS_TEXT =
  'Perform a Consumer Profile search on its own or in conjunction with other Consumer Profiles to obtain comprehensive credit data on an individual.'
export const CONCENT_LBL_1 =
  'I confirm that consent has been received from the individual(s), of which evidence must be made available in the event of an audit.'
export const CONCENT_LBL_2 =
  "I declare I am accessing this information for it's prescribed or contemplated purpose only. I will not alter or amend the credit report."
export const DISCLAIMER =
  'The National Credit Act imposes civil and criminal penalties, including fines and imprisonment against anyone who willingly and wilfully obtains Confidential Information and/or Consumer Credit Information on a consumer from a credit bureau under false pretences and for a purpose not prescribed in the Act. You must obtain consent from the consumer if this is required by the prescribed purpose you have selected.'
export const CONCENT_CPIC_1 =
  "I confirm that consent has been received from the entity's representative, of which evidence must be made available in the event of an audit."
export const CONCENT_CPIC_2 =
  "I confirm that this entity's annual turnover exceeds R1,000,000 (1 million Rand) and - per Section 4(1)(a) of the National Credit Act, No. 34 of 2005 - consent is not required."
export const CONCENT_CPIC_3 =
  "I declare I am accessing this information for it's prescribed or contemplated purpose only. I will not alter or amend the credit report."
export const DOWNLOAD_TEXT =
  'Please download and save your reports for future access'
export const MUNICIPALITIES = [
  { value: '', label: 'Select Municipality' },
  { value: 'Beaufort West', label: 'Beaufort West' },
  { value: 'Bergriview', label: 'Bergrivier' },
  { value: 'Bitou', label: 'Bitou' },
  { value: 'Breede Valley', label: 'Breede Valley' },
  { value: 'Cape Agulhas', label: 'Cape Agulhas' },
  { value: 'Cederberg', label: 'Cederberg' },
  { value: 'City of Cape Town', label: 'City of Cape Town' },
  { value: 'Drakenstein', label: 'Drakenstein' },
  { value: 'George', label: 'George' },
  { value: 'Hessequa', label: 'Hessequa' },
  { value: 'Kannaland', label: 'Kannaland' },
  { value: 'Knysna', label: 'Knysna' },
  { value: 'Laingsburg', label: 'Laingsburg' },
  { value: 'Langeberg', label: 'Langeberg' },
  { value: 'Matzikama', label: 'Matzikama' },
  { value: 'Mossel Bay', label: 'Mossel Bay' },
  { value: 'Oudtshoorn', label: 'Oudtshoorn' },
  { value: 'Overstrand', label: 'Overstrand' },
  { value: 'Prince Albert', label: 'Prince Albert' },
  { value: 'Saldanha Bay', label: 'Saldanha Bay' },
  { value: 'Stellenbosch', label: 'Stellenbosch' },
  { value: 'Swartland', label: 'Swartland' },
  { value: 'Swellendam', label: 'Swellendam' },
  { value: 'Theewaterskloof', label: 'Theewaterskloof' },
  { value: 'Witzenberg', label: 'Witzenberg' },
]
export const PRICELIST = {
  CREDIT_REPORT: 15,
  CONSUMER_TRACE: 11,
  PRECHECK: 10,
  REALTIME_IDV: 10,
  FACEVIEW: 10,
  SANCTION_SCREENING: 20,
  CIPC: 18,
  DETAILED_BUSINESS_REPORT: 80,
  DIRECTOR_ENQUIRY: 12,
  TITLE_DEED: 99,
  DEEDS_QUERY: 29.5,
  SPIDER_SEARCH: 30,
  EUA_ENQUIRY: 29.5,
  BANK_ACCOUNT_VERIFICATION: 11,
}

export const SUBURB = [
  { value: '', label: 'Choose Suburb' },
  { value: 'Aalwyndal', label: 'Aalwyndal, Mossel Bay' },
  { value: 'Abbotsdale', label: 'Abbotsdale, Swartland' },
  {
    value: 'Acacia Park',
    label: 'Acacia Park, City of Cape Town',
  },
  {
    value: 'Admirals Kloof',
    label: 'Admirals Kloof, City of Cape Town',
  },
  {
    value: 'Admirals Park',
    label: 'Admirals Park, City of Cape Town',
  },
  { value: 'Adriaanse', label: 'Adriaanse, City of Cape Town' },
  { value: 'Agulhas', label: 'Agulhas, Cape Agulhas' },
  { value: 'Agulhas Links', label: 'Agulhas Links, Cape Agulhas' },
  { value: 'Airport', label: 'Airport, City of Cape Town' },
  { value: 'Albertinia', label: 'Albertinia, Hessequa' },
  { value: 'Amanda Glen', label: 'Amanda Glen, City of Cape Town' },
  { value: 'Amandelrug', label: 'Amandelrug, City of Cape Town' },
  { value: 'Amandelsig', label: 'Amandelsig, City of Cape Town' },
  { value: 'Amstelhof', label: 'Amstelhof, Drakenstein' },
  {
    value: 'Anchorage Park',
    label: 'Anchorage Park, City of Cape Town',
  },
  { value: 'Annandale', label: 'Annandale, City of Cape Town' },
  {
    value: 'Antilles & Cayman Beach',
    label: 'Antilles & Cayman Beach, City of Cape Town',
  },
  {
    value: 'Arabella Country Estate',
    label: 'Arabella Country Estate, Overstrand',
  },
  { value: 'Arauna', label: 'Arauna, City of Cape Town' },
  {
    value: 'Arbeidslus',
    label: 'Arbeidslus, Stellenbosch',
  },
  {
    value: 'Argonauta',
    label: 'Argonauta, Cape Agulhas',
  },
  {
    value: 'Armoed, Oudtshoorn',
    label: 'Armoed, Oudtshoorn',
  },
  {
    value: 'Arniston',
    label: 'Arniston, Cape Agulhas',
  },
  {
    value: 'Asanda',
    label: 'Asanda, City of Cape Town',
  },
  {
    value: 'Asazani Jccc Camp',
    label: 'Asazani Jccc Camp, Mossel Bay',
  },
  {
    value: 'Ashbury',
    label: 'Ashbury, Langeberg',
  },
  {
    value: 'Ashton',
    label: 'Ashton, Langeberg',
  },
  {
    value: 'Athlone',
    label: 'Athlone, City of Cape Town',
  },
  {
    value: 'Atlantic Beach',
    label: 'Atlantic Beach, City of Cape Town',
  },
  {
    value: 'Atlantis',
    label: 'Atlantis, City of Cape Town',
  },
  {
    value: 'Atlantis Industrial',
    label: 'Atlantis Industrial, City of Cape Town',
  },
  {
    value: 'Audus Estate',
    label: 'Audus Estate, City of Cape Town',
  },
  {
    value: 'Aurora',
    label: 'Aurora, City of Cape Town',
  },
  {
    value: 'Aurora, Bergrivier',
    label: 'Aurora, Bergrivier',
  },
  {
    value: 'Austinville',
    label: 'Austinville, City of Cape Town',
  },
  {
    value: 'Aavalon Estate',
    label: 'Aavalon Estate, City of Cape Town',
  },
  {
    value: 'Avian Park',
    label: 'Avian Park, Breede Valley',
  },
  {
    value: 'Avon',
    label: 'Avon, City of Cape Town',
  },
  {
    value: 'Avondale - Atlantis',
    label: 'Avondale - Atlantis, City of Cape Town',
  },
  {
    value: 'Avondale - Parow',
    label: 'Avondale - Parow, City of Cape Town',
  },
  {
    value: 'Avonwood',
    label: 'Avondwood, City of Cape Town',
  },
  {
    value: 'Baardscheerders Bosch',
    label: 'Baardscheerders Bosch, Overstrand',
  },
  {
    value: 'Bainskloof Estate',
    label: 'Bainskloof Estate, Drakenstein',
  },
  {
    value: 'Bainskloof Pass',
    label: 'Bainskloof Pass, Drakenstein',
  },
  {
    value: 'Ballotsview',
    label: 'Ballotsview, George',
  },
  {
    value: 'Bantry Bay',
    label: 'Bantry Bay, City of Cape Town',
  },
  {
    value: 'Baron View',
    label: 'Baron View, Bitou',
  },
  {
    value: 'Baronetcy',
    label: 'Baronetcy, City of Cape Town',
  },
  {
    value: 'Barrydale',
    label: 'Barrydale, Swellendam',
  },
  {
    value: 'Bay Park',
    label: 'Bay Park, City of Cape Town',
  },
  {
    value: 'Bay View',
    label: 'Bay View, Mossel Bay',
  },
  {
    value: 'Bay View Village',
    label: 'Bay View Village, City of Cape Town',
  },
  {
    value: 'Beachy Head',
    label: 'Beachy Head, Bitou',
  },
  {
    value: 'Beacon Hill',
    label: 'Beacon Hill, City of Cape Town',
  },
  {
    value: 'Beacon Isle',
    label: 'Beacon Isle, Bitou',
  },
  {
    value: 'Beacon Valley',
    label: 'Beacon Valley, City of Cape Town',
  },
  {
    value: 'Beaconvale',
    label: 'Beaconvale, City of Cape Town',
  },
  {
    value: 'Beau Rivage',
    label: 'Beau Rivage, Bitou',
  },
  {
    value: 'Beaufort West',
    label: 'Beaufort West, Beaufort West',
  },
  {
    value: 'Beaufort West Industrial Park',
    label: 'Beaufort West Industrial Park, Beaufort West',
  },
  {
    value: 'Beaufort West Rural',
    label: 'Beaufort West Rural, Beaufort West',
  },
  {
    value: 'Beeskamp',
    label: 'Beeskamp, Witzenberg',
  },
  {
    value: 'Bek Bay',
    label: 'Bek Bay, Saldanha Bay',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
  {
    value: '',
    label: '',
  },
]
export const METROPOLITAN_PROVINCE = [
  { value: '', label: 'Metropolitan Area / Province' },
  { value: 'BUFFALO_CITY', label: 'Buffalo City (East London)' },
  {
    value: 'CITY_OF_CAPE_TOWN',
    label: 'City of Cape Town (Cape Town)',
  },
  {
    value: 'CITY_OF_JOHANNESBURG',
    label: 'City of Johannesburg (Johannesburg)',
  },
  { value: 'CITY_OF_PRETORIA', label: 'City of Tshwane (Pretoria)' },
  { value: 'GERMISTON', label: 'Ekurhuleni (Germiston)' },
]
export const BRIDGING_PROPERTY_OPTIONS = [
  { value: 'ERF_NO', label: 'ERF No' },
  { value: 'STREET_NAME', label: 'Street Name' },
  {
    value: 'SECTIONAL_TITLE_SCHEME_NAME',
    label: 'Sectional Title Scheme Name',
  },
  { value: 'SECURITY_ESTATE_NAME', label: 'Security Estate Name' },
  { value: 'OWNER_NAME', label: 'Owner Name' },
  { value: 'ID_PASSPORT', label: 'ID Number' },
]
export const SEARCH_BY_SELECT_OPTIONS = [
  { value: '', label: '- Search by -' },
  { value: 'REG_NR', label: 'Registration number' },
  { value: 'COMP_NAME', label: 'Company name' },
  { value: 'VAT_NR', label: 'VAT number' },
  { value: 'SOLE_PROP', label: "Sole proprietor's ID" },
]
export const PURPOSE_OF_SEARCH_OPTIONS = [
  {
    value: '',
    label: 'Select prescribed purpose in line with section 18(4) of the ACT',
  },
  {
    value: 'SETTING_LIMIT_FOR_GOODS_UTILITY_SERVICE',
    label: 'Settling Limit for Goods/Utility/Service (Consent required)',
  },
  {
    value: 'TRACING_BY_CREDIT_PROVIDER_AGENT',
    label: 'Tracing by Credit Provider / Agent',
  },
  {
    value: 'FRAUD_CORRUPTION_THEFT_INVESTIGATION',
    label: 'Fraud, Corruption, or Theft Investigation',
  },
  {
    value: 'FRAUD_DETECTION_PREVENTION',
    label: 'Fraud Detection and Fraud Prevention',
  },
  {
    value: 'EMPLOYMENT_HANDLING_FINANCES',
    label: 'Employment – Handling Finances (Consent Required)',
  },
  { value: 'DEBT_COUNSELLING', label: 'Debt Counselling (Consent Required)' },
  {
    value: 'INSURANCE_APPLICATION',
    label: 'Insurance Application (Consent Required)',
  },
  {
    value: 'UNCLAIMED_FUNDS_DISTRIBUTION',
    label: 'Unclaimed Funds Distribution',
  },
  {
    value: 'CREDIT_RISK_MANAGEMENT',
    label: 'Credit Risk Management (Consent Required)',
  },
  {
    value: 'CREDIT_LIMIT_MANAGEMENT',
    label: 'Credit Limit Management (Consent Required)',
  },
  {
    value: 'AFFORDABILITY_ASSESSMENT_CREDIT_PROVIDER',
    label: 'Affordability Assessment by Credit Provider',
  },
  {
    value: 'FINANCIAL_MEANS_ASSESSMENT',
    label: 'Financial Means Assessment (Consent Required)',
  },
  {
    value: 'PRE_SCREENING_ASSESSMENT',
    label: 'Pre-Screening Assessment (Consent Required)',
  },
]
export const CONCENT_OPTIONS = [
  { value: 'option1', label: CONCENT_CPIC_1 },
  { value: 'option2', label: CONCENT_CPIC_2 },
]
export const INVALID_ID_WARNING = `Please ensure that you enter the correct format, South African Id numbers must be 13 digits
  in length.`
export const INVALID_VAT_WARNING = `Please ensure that you enter the correct format, South African VAT number must be 10 digits
 in length, and start with a 4.`
export const INVALID_REG_NUMBER_WARNING = `Please ensure that you enter the correct format. For example: "K2018/535559 /05"`
export const INVALID_KIM_WARNING = `Please ensure that you enter valid Kim number, it should contain at least one letter followed by one or more digits.`
export const API_ERROR_MESSAGE = `Sorry, we have encountered a problem. Please contact CMA support at support@cmainfo.co.za for assistance.`
export const INCORRECT_OTP_ERROR_MESSAGE = `Incorrect OTP. Please try again.`
export const OTP_ERROR_MESSAGE = `An error occurred while sending OTP. Please try again.`
export const NO_RESULTS_FOUND = `No results found. Please try again.`
export const INCORRECT_REGISTRATION_NUMBER = `You may have used the wrong format when entering your registration number, please try again.`
export const CONSUMER_TRACE_OPTIONS = {
  searchBy: [
    { value: 'ID_NUMBER', label: 'Id number' },
    { value: 'CONTACT_DETAILS', label: 'Contact details' },
    { value: 'PASSPORT_NUMBER', label: 'Passport number' },
    { value: 'PERSONAL_DETAILS', label: 'Personal details' },
  ],
  searchType: [
    { value: 'AGE', label: 'Age' },
    { value: 'DATE_OF_BIRTH', label: 'Date of birth' },
  ],
  prescribedPurposes: [
    {
      value: '',
      label: 'Select prescribed purpose in line with section 18(4) of the ACT',
    },
    {
      value: 'SETTING_LIMIT_FOR_GOODS_UTILITY_SERVICE',
      label: 'Setting Limit for Goods/Utility/Service (Consent Required)',
    },
    {
      value: 'TRACING_BY_CREDIT_PROVIDER_AGENT',
      label: 'Tracing by Credit Provider/Agent',
    },
    {
      value: 'FRAUD_CORRUPTION_THEFT_INVESTIGATION',
      label: 'Fraud, Corruption, or Theft Investigation',
    },
    {
      value: 'FRAUD_DETECTION_PREVENTION',
      label: 'Fraud Detection and Fraud Prevention',
    },
    {
      value: 'DEPLOYMENT_HANDLING_FINANCES',
      label: 'Employment - Handling Finances (Consent Required)',
    },
    { value: 'DEBT_COUNSELLING', label: 'Debt Counselling (Consent Required)' },
    {
      value: 'INSURANCE_APPLICATION',
      label: 'Insurance Application (Consent Required)',
    },
    {
      value: 'UNCLAIMED_FUNDS_DISTRIBUTION',
      label: 'Unclaimed Funds Distribution',
    },
    {
      value: 'CREDIT_RISK_MANAGEMENT',
      label: 'Credit Risk Management (Consent Required)',
    },
    {
      value: 'CREDIT_LIMIT_MANAGEMENT',
      label: 'Credit Limit Management (Consent Required)',
    },
    {
      value: 'AFFORDABILITY_ASSESSMENT_CREDIT_PROVIDER',
      label: 'Affordability Assessment by Credit Provider',
    },
    {
      value: 'FINANCIAL_MEANS_ASSESSMENT',
      label: 'Financial Means Assessment (Consent Required)',
    },
    {
      value: 'PRE_SCREENING_ASSESSMENT',
      label: 'Pre-Screening Assessment (Consent Required)',
    },
  ],
}

export const DETAILED_BUSINESS_REPORT_OPTIONS = {
  searchBy: [
    { value: '', label: '- Search by -' },
    { value: 'REG_NR', label: 'Registration number' },
    { value: 'ID_NR', label: "Sole proprietor's ID" },
    { value: 'VAT_NR', label: 'VAT number' },
    { value: 'COMP_NAME', label: 'Company name' },
  ],
  PrescribedPurpose: [
    {
      value: '',
      label: 'Select prescribed purpose in line with section 18(4) of the ACT',
    },
    {
      value: 'SettingLimit',
      label: 'Setting Limit for Goods/Utility/Service (Consent Required)',
    },
    { value: 'TracingByCredit', label: 'Tracing by Credit Provider/Agent' },
    {
      value: 'FraudCorruptionTheft',
      label: 'Fraud, Corruption, or Theft Investigation',
    },
    {
      value: 'FraudDetectionPrevention',
      label: 'Fraud Detection and Fraud Prevention',
    },
    {
      value: 'EmploymentHandlingFinances',
      label: 'Employment - Handling Finances(Consent Required)',
    },
    { value: 'DebtCounselling', label: 'Debt Counselling (Consent Required)' },
    {
      value: 'InsuranceApplication',
      label: 'Insurance Application (Consent Required)',
    },
    {
      value: 'UnclaimedFundsDistribution',
      label: 'Unclaimed Funds Distribution',
    },
    {
      value: 'CreditRiskManagement',
      label: 'Credit Risk Management (Consent Required)',
    },
    {
      value: 'CreditLimitManagement',
      label: 'Credit Limit Management (Consent Required)',
    },
    {
      value: 'AffordabilityAssessmentCP',
      label: 'Affordability Assessment by Credit Provider',
    },
    {
      value: 'FinancialMeansAssessment',
      label: 'Financial Means Assessment (Consent Required)',
    },
    {
      value: 'PreScreeningAssessment',
      label: 'Pre-Screening Assessment (Consent Required)',
    },
  ],
}

export const DEEDS_OFFICE_PERSON_OPTIONS = {
  searchBy: [
    { value: 'INDIVIDUAL', label: 'Individual' },
    { value: 'COMPANY', label: 'Company' },
  ],
  offices: [
    { name: 'Bloemfontein', id: '1', checked: false },
    { name: 'Cape Town', id: '2', checked: false },
    { name: 'Johannesburg', id: '3', checked: false },
    { name: 'Kimberley', id: '4', checked: false },
    { name: 'King Williams Town', id: '5', checked: false },
    { name: 'Pietermaritzburg', id: '6', checked: false },
    { name: 'Umtata', id: '7', checked: false },
    { name: 'Vryburg', id: '8', checked: false },
    { name: 'Limpopo', id: '9', checked: false },
  ],
}
export const SANCTION_SCREENING_OPTIONS = {
  searchBy: [
    { value: '', label: '- Search by -' },
    { value: 'INDIVIDUAL', label: 'Individual' },
    { value: 'COMPANY', label: 'Company' },
  ],
}
export const SPIDER_SEARCH_OPTIONS = {
  searchBy: [
    { value: 'INDIVIDUAL', label: 'Person' },
    { value: 'TRUST', label: 'Trust' },
    { value: 'COMPANY', label: 'Company' },
  ],
}

// @ts-ignore
export const BANK_VERIFICATION_SEARCH_OPTIONS = {
  searchBy: [
    { value: 'INDIVIDUAL', label: 'Individual' },
    { value: 'COMPANY', label: 'Company' },
    { value: 'TRUST', label: 'Trust' },
  ],
}

export const BANK_VERIFICATION_BRANCH_CODE_OPTIONS = {
  searchBy: [
    { id: '632005', name: 'ABSA - 632005' },
    { id: '430000', name: 'African Bank - 430000' },
    { id: '470010', name: 'Capitec - 470010' },
    { id: '250655', name: 'FNB / First National Bank - 250655' },
    { id: '580105', name: 'Investec - 580105' },
    { id: '198765', name: 'Nedbank - 198765' },
    { id: '051001', name: 'Standard Bank - 051001' },
    { id: '679000', name: 'Discovery Bank - 679000' },
    { id: '683000', name: 'Sasfin Bank - 683000' },
  ],
}

export const BANK_VERIFICATION_ACCOUNT_TYPE_OPTIONS = {
  searchBy: [
    { id: 'SAVINGSACCOUNT', name: 'Savings Account' },
    { id: 'CURRENTCHEQUEACCOUNT', name: 'Current Account' },
    { id: 'TRANSMISSION', name: 'Transmission Account' },
  ],
}

export const BANK_VERIFICATION_REASON = {
  searchBy: [
    { id: 'CONSENT RECEIVED', name: 'Consent Received' },
    {
      id: 'FRAUD PREVENTION / INVESTIGATION',
      name: 'Fraud Prevention / Investigation',
    },
  ],
}

export const _initialState = {
  creditReportOwnerEnquiry: {
    identityNumber: '',
    reference: '',
  },
  creditReportById: {
    identityNumber: '',
    reference: '',
  },
  deedsOfficeSearch: {
    searchBySelectedOption: '',
    totalCost: '',
    surname: '',
    forenames: '',
    initials: '',
    idNumber: '',
    reference: '',
    companyTrustName: '',
    registrationNumber: '',
  },
  trust: {
    trustName: '',
    trustFileNumber: '',
    trustReference: '',
    price: '',
  },
  realTimeIdv: {
    idNumber: '',
    reference: '',
    price: '',
  },
  faceView: {
    idNumber: '',
    reference: '',
    price: 0,
  },
  consumerTrace: {
    idNumber: '',
    contactNumber: '',
    passportNumber: '',
    birthYear: '',
    firstName: '',
    dob: '',
    reference: '',
    isTermsChecked: false,
    prescribedPurposeSelectedOption: '',
    searchBySelectedOption: '',
    searchTypeSelectedOption: '',
  },
  sanctionScreening: {
    country: '',
    surname: '',
    forenames: '',
    reference: '',
    idNumber: '',
    dob: '',
    companyName: '',
    registrationNumber: '',
    searchBySelectedOption: '',
    isMounted: false,
  },
  cipcReport: {
    companyName: '',
    companyRegistrationNumber: '',
    companySoleProprietorId: '',
    companyVATNumber: '',
  },

  detailedBusinessReport: {
    cipcSearchParam: '',
    searchBySelectedOption: '',
    registrationNumber: '',
    businessName: '',
    kimNumber: '',
    idNumber: '',
    reference: '',
    isIncludeDirectorsChecked: false,
  },
  directorEnquiry: {
    surname: '',
    forenames: '',
    idNumber: '',
    reference: '',
    reportId: 0,
  },
}
